<template>
  <v-form ref="form">
    <v-text-field
      :label="$tc('entities.report.props.params',2)"
      :rules="$isRequiredRule"
      v-model="model"
      @input="$emit('input',model)"
      clearable
    ></v-text-field>
  </v-form>
</template>

<script>
import formValidationMixin from "@/mixins/formValidationMixin.js";
export default {
  props: {
    value: {}
  },
  mixins: [formValidationMixin],
  watch:{ value(){this.model = this.value}},
  data(){
      return{
          model:""
      }
  },
  mounted(){ this.model = this.value}
};
</script>